export const GET_TESTIMONIAL = "GET_TESTIMONIAL"
export const GET_TESTIMONIAL_FAIL = "GET_TESTIMONIAL_FAIL"
export const GET_TESTIMONIAL_SUCCESS = "GET_TESTIMONIAL_SUCCESS"
export const GET_TESTIMONIAL_RESET = "GET_TESTIMONIAL_RESET"


export const getTestimonial = (params) => {
    return { type: GET_TESTIMONIAL, params }
}
export const getTestimonialFail = (response) => {
    return { type: GET_TESTIMONIAL_FAIL, response }
}
export const getTestimonialSuccess = (response) => {
    return { type: GET_TESTIMONIAL_SUCCESS, response }
}
export const getTestimonialReset = () => {
    return { type: GET_TESTIMONIAL_RESET }
}